import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { HeaderColumnComponent } from '../header-column.component';

@Component({
  selector: 'app-header-column-craft-designation',
  templateUrl: './header-column-craft-designation.component.html',
  styleUrls: ['./header-column-craft-designation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderColumnCraftDesignationComponent extends HeaderColumnComponent {}
